import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";

import { QK } from "../../../../../base/qk";
import {
  deleteVisitByID,
  getVisitByClientID,
} from "../../../../../api/services/scheduling";
import ConfirmModal from "../../../../ConfirmModal/ConfirmModal";
import EditScheduleModal from "../../../../../screens/VisitPlanScreen/VisitPlanModal/EditScheduleModal";
import VisitCallHeader from "./VisitCall/VisitCallHeader";
import VisitCallCard from "./VisitCall/VisitCallCard";
import ManageCallVisitModal from "./VisitCall/ManageCallVisitModal";

const VisitCall = () => {
  const queryClient = useQueryClient();
  const { id: clientID } = useParams();

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [rowID, setRowID] = useState(null);
  const [selectedID, setSelectedID] = useState(null);
  const [area, setArea] = useState(null);

  const { data: visits } = useQuery([QK.visits, clientID, 2], () =>
    getVisitByClientID(clientID, 2)
  );

  const deleteMutation = useMutation((visitID) => deleteVisitByID(visitID), {
    onSuccess: () => queryClient.invalidateQueries([QK.visits, clientID]),
  });

  const handleDelete = (id) => {
    setRowID(id);
    setShowConfirmModal(true);
  };

  const handleEdit = (id, areaId) => {
    setSelectedID(id);
    setArea(areaId);
    setShowUpdateModal(true);
  };

  const handleConfirm = () => {
    deleteMutation.mutate(rowID);
    setShowConfirmModal(false);
  };

  return (
    <Box sx={{ mt: 0 }}>
      <VisitCallHeader onCreate={() => setShowCreateModal(true)} />

      <Grid container spacing={2.5}>
        {visits?.map((visit) => (
          <Grid item xs={12} sm={6} md={4} key={visit.id}>
            <VisitCallCard
              visit={visit}
              onDelete={handleDelete}
              onEdit={handleEdit}
            />
          </Grid>
        ))}
      </Grid>

      <ManageCallVisitModal
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
      />

      <EditScheduleModal
        area={area}
        show={showUpdateModal}
        handleClose={() => setShowUpdateModal(false)}
        clientId={clientID}
        visitId={selectedID}
      />

      <ConfirmModal
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        handleConfirm={handleConfirm}
        title="Remove Visit"
        body="Are you sure you want to delete this schedule?"
      />
    </Box>
  );
};

export default VisitCall;